import axios from "@/widgets/shared/utils/axios-instance";

export async function initEvent({commit, dispatch}, {eventSlug}) {
  await dispatch("loadEvent", {eventSlug});

  // Load event data simultaneously
  await dispatch("loadComponents");

  // Load simultaneously remaining data
  // Requires loaded components
  await dispatch("loadRestricted");
}

export async function loadEvent({commit, dispatch}, {eventSlug}) {
  const res = await axios.get(`events/lp/${eventSlug}`);
  commit("setEvent", res.data);
}

export async function loadComponents({dispatch, state}) {
  const eventId = state["eventId"];
  await dispatch("components/loadComponents", {eventId}).then(async () => {
    await dispatch("collectAgendas");
  });
}

export async function loadRestricted({commit, dispatch, state}) {
  if (state.token && state.lpMode) {
    await dispatch("loadMeetings");
    await dispatch("loadSchedule");
    await dispatch("loadUserTickets");
  } else {
    commit("meetings/setMeetings", []);
    commit("schedule/setSessions", []);
    commit("agendaSessionTickets/setTickets", []);
    commit("agendaSessionAttendees/clearAttendees");
  }
}

export async function loadSessions({dispatch, state, getters}) {
  const agendaComponents = getters["components/agendaComponents"];
  const componentIds = agendaComponents.map(component => component.id);

  await dispatch("sessions/loadSessions", componentIds);
}

export async function loadSessionsFromComponent({dispatch, state, getters}, componentId) {
  const eventId = state["eventId"];
  await dispatch("sessions/loadSessions", {eventId, componentIds: [componentId]});
}

export async function loadSchedule({dispatch, state}) {
  const eventId = state["eventId"];
  await dispatch("schedule/loadSchedule", eventId);
}

export async function loadMeetings({dispatch, state, getters}) {
  const eventId = state["eventId"];
  const bmComponents = getters["components/businessMatchingComponents"];
  const componentIds = bmComponents.map(component => component.id);

  await dispatch("meetings/loadMeetings", {eventId, componentIds});
}

export async function loadUserTickets({dispatch}) {
  await dispatch("agendaSessionTickets/loadUserTickets");
}

export async function collectAgendas({dispatch, state, getters}) {
  const components = getters["components/allComponents"];
  const prependMySchedule = !!state.token && state.lpMode;

  await dispatch("agendas/collectComponents", {components, prependMySchedule});
}

export async function deepReloadData({dispatch, state, commit}, {eventSlug}) {
  const currentlySelectedComponentId = state.agendas.selectedId;
  await dispatch("loadEvent", {eventSlug});
  await dispatch("loadComponents");
  await commit("sessions/reset");
  if (currentlySelectedComponentId !== -1) {
    await dispatch("sessions/loadSessions", {componentId: currentlySelectedComponentId, force: true});
  }
  if (state.token && state.lpMode) {
    await dispatch("loadSchedule");
  }
}
